import _slicedToArray from "C:\\Code\\old_shopify_apps\\free-shipping-progress-bar\\free-shipping-progress-bar-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import React$1, { useRef, useState } from 'react';
import { useUniqueId } from '../../utilities/unique-id/hooks.js';
import { classNames } from '../../utilities/css.js';
import { useToggle as useToggle$1 } from '../../utilities/use-toggle.js';
import { Choice as Choice$1, helpTextID } from '../Choice/Choice.js';
import styles from './RadioButton.scss.js';
function RadioButton(_ref) {
  var ariaDescribedByProp = _ref.ariaDescribedBy,
    label = _ref.label,
    labelHidden = _ref.labelHidden,
    helpText = _ref.helpText,
    checked = _ref.checked,
    disabled = _ref.disabled,
    onChange = _ref.onChange,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    idProp = _ref.id,
    nameProp = _ref.name,
    value = _ref.value;
  var id = useUniqueId('RadioButton', idProp);
  var name = nameProp || id;
  var inputNode = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    keyFocused = _useState2[0],
    setKeyFocused = _useState2[1];
  var _useToggle$ = useToggle$1(false),
    mouseOver = _useToggle$.value,
    handleMouseOver = _useToggle$.setTrue,
    handleMouseOut = _useToggle$.setFalse;
  var handleKeyUp = function handleKeyUp() {
    !keyFocused && setKeyFocused(true);
  };
  var handleBlur = function handleBlur() {
    onBlur && onBlur();
    setKeyFocused(false);
  };
  function handleChange(_ref2) {
    var currentTarget = _ref2.currentTarget;
    onChange && onChange(currentTarget.checked, id);
  }
  var describedBy = [];
  if (helpText) {
    describedBy.push(helpTextID(id));
  }
  if (ariaDescribedByProp) {
    describedBy.push(ariaDescribedByProp);
  }
  var ariaDescribedBy = describedBy.length ? describedBy.join(' ') : undefined;
  var inputClassName = classNames(styles.Input, keyFocused && styles.keyFocused);
  var backdropClassName = classNames(styles.Backdrop, mouseOver && styles.hover);
  return /*#__PURE__*/React$1.createElement(Choice$1, {
    label: label,
    labelHidden: labelHidden,
    disabled: disabled,
    id: id,
    helpText: helpText,
    onMouseOver: handleMouseOver,
    onMouseOut: handleMouseOut
  }, /*#__PURE__*/React$1.createElement("span", {
    className: styles.RadioButton
  }, /*#__PURE__*/React$1.createElement("input", {
    id: id,
    name: name,
    value: value,
    type: "radio",
    checked: checked,
    disabled: disabled,
    className: inputClassName,
    onChange: handleChange,
    onFocus: onFocus,
    onKeyUp: handleKeyUp,
    onBlur: handleBlur,
    "aria-describedby": ariaDescribedBy,
    ref: inputNode
  }), /*#__PURE__*/React$1.createElement("span", {
    className: backdropClassName
  })));
}
export { RadioButton };